var webinar = {
    title:"Webinar Marival Resorts",
    subtitle:"Conoce Marival Resorts con Marc Murphy.",
    unsupported:"Tu navegador no soporta la reproducción de video."
}
module.exports = webinar
